import moment from 'moment';

const uniqueFilename = (filename) => {
  const extension = filename.split('.').pop();
  const name = filename.split('.').slice(0, -1).join('.');
  return name + moment().format() + '.' + extension;
};

export default uniqueFilename;
